
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import { ClientDetailUpdateItem } from '@/domain/entities/ClientManagement';
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";

class Props {
  isManagement = prop<boolean>({
    required: false,
    default: false,
    type: Boolean
  });
}
@Options({
  components: {
    Title
  }
})
class DetailBillingInformation extends Vue.with(Props) {
  get detailData() {
    if (this.isManagement) {
      return ClientManagementController.detailClientManagement;
    }

    return ClientRegistrationController.clientRegistrationDetail;
  }

  get isMY() {
    return this.detailData.clientCountry === "MY";
  }

  get formattedWhatsappNumber() {
    if (this.isMY) return `+${this.detailData.clientBilling.noWhatsAppFull}`;
    return this.detailData.clientBilling.formattedWhatsappNumber;
  }

  get newestUpdated() {
    if (this.detailData.detailUpdate.newestUpdatedBillingInfo.length) {
      return this.detailData.detailUpdate.newestUpdatedBillingInfo[0]
    }

    return new ClientDetailUpdateItem({
      updatedByName: this.detailData.clientCreatedBy,
      updatedAt: formatDate(this.detailData.clientCreatedAt)
    })
  }
}
export default DetailBillingInformation;
